import { render, staticRenderFns } from "./TotalSimilarPlayers.vue?vue&type=template&id=00be5c96&"
import script from "./TotalSimilarPlayers.vue?vue&type=script&lang=js&"
export * from "./TotalSimilarPlayers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports